import React, { useEffect, useRef } from 'react'
import { View, TextInput as TI, Platform } from 'react-native'
import { spacing } from '../../theme/spacing'
import { Text } from '../text'
import { TextInputProps } from './text-input.props'

import { typography } from '../../theme/typography'
import { SvgIcon } from '../svg-icon'
import { iconSearch } from '../../assets'
import { color } from '../../theme'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'
import { useStores } from '@trivie/core'

// Updates the height of a <textarea> when the value changes.
export function useAutosizeTextArea(textAreaRef: HTMLTextAreaElement | null, value: string) {
  useEffect(() => {
    if (textAreaRef && Platform.OS === 'web') {
      //shouldn't override native behavior of 'multiline' of TextInput component

      textAreaRef.style.height = '0px'
      const scrollHeight = textAreaRef.scrollHeight

      textAreaRef.style.height = scrollHeight + 'px'
    }
  }, [textAreaRef, value])
}

export const TextInput = observer((props: TextInputProps) => {
  const {
    style,
    label,
    placeholder,
    placeholderTx,
    editable,
    secureTextEntry,
    value,
    onBlur,
    onFocus,
    onChangeText,
    keyboardType,
    inlineImageLeft,
    inputStyle,
    multiline,
    autoCapitalize,
    placeholderTextColor,
    search,
    helperText,
    showHelper,
    showBorder,
    allowExtendArea,
  } = props

  const { t } = useTranslation()

  const { uiStore } = useStores()

  const i18nPlaceholderText = placeholderTx && t(placeholderTx)
  const placeholderContent = i18nPlaceholderText || placeholder

  const textAreaRef = useRef(null)
  useAutosizeTextArea(textAreaRef.current, allowExtendArea ? value || '' : '')

  return (
    <>
      <View style={{ ...style }}>
        {label ? (
          <Text variant="body2" style={{ opacity: 0.5, marginBottom: spacing[1] }} tx={label} />
        ) : null}
        {search && (
          <View style={{ flexDirection: 'column', justifyContent: 'center' }}>
            <SvgIcon src={iconSearch} size={24} viewBox="0 0 24 24" color={color.shade50} />
          </View>
        )}
        {inlineImageLeft && (
          <View style={{ flexDirection: 'column', top: Platform.OS === 'android' ? 36 : 21 }}>
            <SvgIcon src={inlineImageLeft} size={24} viewBox="0 0 24 24" color={'#262626'} />
          </View>
        )}
        <TI
          ref={textAreaRef}
          allowFontScaling={false}
          multiline={multiline}
          onChangeText={onChangeText}
          onBlur={onBlur}
          onFocus={onFocus}
          autoCapitalize={autoCapitalize as any}
          value={value ?? ''}
          placeholderTextColor={placeholderTextColor || color.darkenGrey}
          secureTextEntry={secureTextEntry ?? false}
          editable={editable ?? true}
          placeholder={placeholderContent}
          keyboardType={keyboardType ?? 'default'}
          maxLength={props.maxLength}
          style={{
            ...typography.title,
            // fontWeight: String(typography.fontWeight),
            color: color.black,
            borderBottomWidth: showBorder ? 1 : 0,
            borderBottomColor: color.shade10,
            paddingBottom: 12,

            alignItems: 'center',
            paddingLeft: search ? 6 : inlineImageLeft ? 40 : 0,
            ...inputStyle,
            fontFamily: uiStore.branding.font_family,
          }}
        />
        {showHelper && (
          <Text
            text={helperText}
            variant="body2"
            style={{
              marginTop: 8,
              color: '#FF0000',
              // position: 'absolute',
              textAlign: 'left',
            }}
          />
        )}
      </View>
    </>
  )
})
